export default "__VITE_ASSET__ebdbb5ba__"